import { createVitals } from "../../api/historyService";

export const useCreateVitals = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createVitals(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create vitals:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};